const COMMON_FETCH_USERS = {
  START: 'START_COMMON_FETCH_USERS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_USERS',
  FAIL: 'FAIL_COMMON_FETCH_USERS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_USERS',
}

export default COMMON_FETCH_USERS
